var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VuePerfectScrollbar',{staticClass:"d-flex flex fill flex-row",staticStyle:{"height":"calc(100dvh - 4rem)"}},[_c('div',{staticClass:"card d-flex flex-row flex fill p-2 m-0"})])
}
var staticRenderFns = []

export { render, staticRenderFns }